export const RoleNames = {
  Alumni: "Alumni",
  Admin: "Admin",
  Employee: "Employee",
} as const;

export type RoleName = typeof RoleNames[keyof typeof RoleNames];

export default RoleNames;
